import { apiClient } from '@/app/utils/Request';

// 对应后端 Express /users 路由：
// POST /users/register
// POST /users/login
// POST /users/admin-login  （管理员：校验 admin=1，与普通登录分离）
// GET  /users/profile
// PUT  /users/profile
// GET  /users/:id
// GET  /users/list

export interface RegisterPayload {
  email: string;
  password: string;
  phone_number?: string;
  first_name?: string;
  last_name?: string;
  company?: string;
  country?: string;
  postal_code?: string;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface AdminLoginPayload {
  email: string;
  password: string;
  captcha: string;
}

export interface AuthUser {
  id: number;
  email: string;
  token: string;
}

/** POST /users/admin-login 成功时的 data */
export interface AdminAuthUser {
  id: number;
  email: string;
  admin: 1;
  token: string;
}

export interface UserProfile {
  id: number;
  email: string;
  phone_number: string | null;
  first_name: string | null;
  last_name: string | null;
  company: string | null;
  country: string | null;
  postal_code: string | null;
  is_active: 0 | 1;
  created_at: string;
  updated_at: string;
}

export interface ApiResponse<T = unknown> {
  code: number;
  message: string;
  data: T;
}

// 注册
export function register(data: RegisterPayload) {
  return apiClient.post<ApiResponse<AuthUser>>('/users/register', data);
}

// 登录
export function login(data: LoginPayload) {
  return apiClient.post<ApiResponse<AuthUser>>('/users/login', data);
}

/** 管理后台登录（body: email + password + captcha；后端校验 admin=1） */
export function adminLogin(data: AdminLoginPayload) {
  return apiClient.post<ApiResponse<AdminAuthUser>>('/users/admin-login', data);
}

// 获取当前登录用户信息（需要 Bearer token，Request 拦截器会自动加 Authorization）
export function getProfile() {
  return apiClient.get<ApiResponse<UserProfile>>('/users/profile');
}

// 更新当前登录用户信息（需要 Bearer token）
export type UpdateProfilePayload = Partial<{
  phone_number: string | null;
  first_name: string | null;
  last_name: string | null;
  company: string | null;
  country: string | null;
  postal_code: string | null;
}>;

export function updateProfile(data: UpdateProfilePayload) {
  return apiClient.put<ApiResponse<UserProfile>>('/users/profile', data);
}

// 修改密码（需要 Bearer token）
export interface ChangePasswordPayload {
  old_password: string;
  new_password: string;
}

export function changePassword(data: ChangePasswordPayload) {
  return apiClient.put<ApiResponse<null>>('/users/password', data);
}

// 按用户 ID 获取用户信息（需要 Bearer token）
export function getUserById(id: number | string) {
  return apiClient.get<ApiResponse<UserProfile>>(`/users/${id}`);
}

// 示例：调用 /users/list
export function getUserTestList() {
  return apiClient.get<ApiResponse>('/users/list');
}

